export default __webpack_public_path__ + "static/media/about.acc6d267.svg";